/**
 * A page that needs an account (Library, Words, Practice, Progress), in trial
 * mode: the sign-in form in its place, rather than an empty page under a modal
 * which, closed, leaves nothing there
 */
import * as preact from "preact";

import { type PreactPageProps } from "pages/PreactPage";
import stores from "stores/stores";
import { SignupComponent } from "views/SignupView";

export default class SignInPromptPageView extends preact.Component<PreactPageProps> {
  render() {
    return (
      <div class="signInPrompt">
        <h1>{this.props.options.heading}</h1>
        <SignupComponent stores={stores} />
      </div>
    );
  }
}
